import { type IncomingCallStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/IncomingCall'
import { type CallEndsStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/CallEnds'
import { type PlayAudioStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/PlayAudio'
import { type SendToVoicemailStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/SendToVoicemail'
import { type RingStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/Ring'
import { type ForwardCallStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/ForwardCall'
import { type CallQueueStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/CallQueue'

export type ISmartCallFlowAction =
  | IncomingCallStore
  | CallQueueStore
  | SendToVoicemailStore
  | CallEndsStore
  | RingStore
  | ForwardCallStore
  | PlayAudioStore

export const allSmartCallFlowActionTypes = [
  'incomingCall',
  'ring',
  'call_queue',
  'sendToVoicemail',
  'playAudio',
  'ivr',
  'forwardCall',
  'sendSMS',
  'businessHours',
  'aiTextingAgent',
  'aiCallingAgent',
  'callEnds',
] as const

export type ISmartCallFlowActionType = (typeof allSmartCallFlowActionTypes)[number]
